import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Login from './Containers/Login/Login';
import Home from './Containers/Home/Home';
import DownloadData from './Containers/DownloadData/DownloadData';
import ChartPages from './Containers/ChartPages/ChartPages';
import DamChart from './Containers/ChartPages/DamChart';
import Logout from './Components/Logout/Logout';
import Test from './Containers/Test';
import ListView from './Containers/ListView/ListView';
import WareHouse from './Containers/ChartPages/WareHouse';
import WeatherStation from './Containers/ChartPages/WeatherStation';
import Watershed from './Containers/ChartPages/Watershed';
import Map from './Components/Map/Map';
import Guideline from './Containers/Guideline';
import AquiferChart from './Containers/ChartPages/AquiferChart';


const App = () => {
  const userIsAuthorized = useSelector((state) => state.auth.IsAuthorized);

  if (!userIsAuthorized) {
    return (
      <Switch>
        <Route path='/login' exact component={Login} />
        <Redirect to='/login' />
      </Switch>
    );
  } else {
    return (
      <Switch>
        <Route path='/' exact component={Home} />
        <Route path='/logout' exact component={Logout} />

        <Route path='/DownloadData/:type' exact component={DownloadData} />

        <Route path='/DamChart' exact component={DamChart} />
        <Route path='/Chart/WareHouse' exact component={WareHouse} />
        <Route path='/Chart/WeatherStation' exact component={WeatherStation} />
        <Route path='/Chart/Watershed' exact component={Watershed} />
        <Route path='/Chart/Aquifer' exact component={AquiferChart} />
        <Route path='/Chart/:type' exact component={ChartPages} />
        <Route path='/Guideline' exact component={Guideline} />
        <Route path='/Map' exact component={Map} />
        <Route path='/ListView' exact component={ListView} />
        <Route path='/Test' exact component={Test} />

        <Redirect to='/' />
      </Switch>
    );
  }
};

export default App;
